// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 600px) {
    #guest-registration-procedure{
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently
                                    supported by Chrome, Edge, Opera and Firefox */
        overflow: hidden;

        position: absolute;
        top:0;
        left:0;
        width:100%;
        height: 100vh;
        background: black;
    }
    #guest-registration-procedure .container{
        margin: auto;
        margin-top: 10vh;
        background: white;
        position:relative;
        border: 5px solid rgba(0,0,0,1);
        transition: 1s border;
        padding-top:1em;
    }
    #guest-registration-procedure .container-border{
        border: 5px solid rgba(200,200,200,.5);
    }
    #guest-registration-procedure .container h1{
        text-align: center;
        border: 0;
        margin: 0;
        font-size: calc(26px + 1vw);
        color: black;
        transition: opacity 2s;
    }
    #guest-registration-procedure .container h1 i{
        margin-right: .3em;
    }
    #guest-registration-procedure .container input{
        font-family: 'Source Code Pro', monospace;
        border: 0;
        border-radius: 10px;
        border-bottom: 2px solid rgba(10,10,10,.7);
        /* box-shadow: 1px 0 10px 1px rgba(100,100,100,1); */
        font-size: 1.5vw;
        padding: 0.5em;
        background: white;
        color: black;
        margin: auto;
        margin-top: 1.5em;
        display: block;
        outline: none;
        transition: opacity 2s;
        width: 100%;
    }
    #guest-registration-procedure .container button{
        font-family: 'Source Code Pro', monospace;
        display: inline-block;
        border: 0;
        border-radius: 10px;
        background: white;
        padding: 0.25em 0.5em;
        cursor: pointer;
        color: black;
        font-weight: bold;
        transition: opacity 2s;
        font-size: 1.5vw;
        margin-top: 3.5em;
        margin-bottom: 0.5em;
    }
    #guest-registration-procedure #btns{
        display:flex;
        justify-content: space-between;
    }
    #guest-registration-procedure .container button#cancel-btn{
        box-shadow: 1px 0 5px 0.3px rgba(100,10,10,.5);
        background:rgba(100,0,0,.3);
    }
    #guest-registration-procedure .container button#cancel-btn:hover{
        box-shadow: 1px 0 5px 0.5px rgba(100,10,10,.8);
    }
    #guest-registration-procedure .container button#continue-btn{
        box-shadow: 1px 0 5px 0.3px rgba(10,100,10,.5);
        background:rgba(0,100,0,.3);
    }
    #guest-registration-procedure .container button#continue-btn:hover{
        box-shadow: 1px 0 5px 0.5px rgba(10,100,10,.8);
    }

    #sipario-h{
        position: absolute;
        width: 100%;
        height: 100%;
        background: black;
        left: 0;
        top: 0;
        transition: 3s top;
    }
    .sipario-h-off{
        top: 100vh!important;
    }
    .sipario-w{
        position: absolute;
        width: 100%;
        height: 100%;
        background: black;
        left: 0;
        top: 0;
        transition: 3s width;
    }
    .sipario-w-off{
        width: 0!important;
    }
    .step-on{
        z-index: 10;
        opacity: 1;
    }
    .step-off{
        z-index:-1;
        opacity: 0;
    }
    .d-none{
        display:none;
    }

    #secondo-step{
        text-align:center;
    }
    #secondo-step input{
        width: 8vw!important;
        text-align: center!important;
        font-weight: bold;
        border: 2px solid black!important;
        font-size: 2vw!important;
        padding: 0.2em!important;
    }
    h3{
        font-size:2.3vw!important;
    }
    #secondo-step h1 label{
        display:inline-block;
        color: rgba(0,0,0,.8);
    }
    #secondo-step #regenerate-btn {
        box-shadow: 1px 0 5px 0.3px rgba(10,10,100,.5);
        background: rgba(0,0,100,.3);
        margin-top: 1em!important;
    }
    .input-error{
        border-bottom: 2px solid rgba(100,10,10,.9)!important;
    }
    #terzo-step h1{
        color:rgba(0,80,0,.9)!important;
    }
    #terzo-step h1 label{
        color: rgba(0,100,0,.9);
    }
    #terzo-step h2, #quarto-step h2{
        text-align: center;
        font-size: 1.4vw;
        margin-bottom: 1.5em;
    }
    #terzo-step button, #quarto-step button{
        display: block!important;
        margin: auto!important;
        border: 1px solid rgba(0,0,0,.4)!important;
        margin-bottom: 0.5em!important;
    }
    #quarto-step h1 label{
        color: rgba(10,10,10,.8);
    }
    #quarto-step h2{
        font-size:1.5vw;
        margin-top:1em;
    }
    #quarto-step #btns {
        margin-top:6em;
        margin-bottom: 1em;
    }
    #quarto-step #btns button {
        margin:0!important;
        outline:none!important;
    }
    #quarto-step button.selected{
        border: 1px solid rgba(255, 115, 0, 0.9)!important;
        color: rgba(255, 115, 0, 0.9);
        font-weight:bold;
        outline:none!important;
    }
    #quarto-step input[type=date]{
        width: 10em;
        margin-top: 0;
        margin-bottom:1em;
    }
    .color-error{
        color:red;
    }
    #quinto-step h1{
        color:rgba(0,80,0,.9)!important;
    }
    #quinto-step h1 label{
        color: rgba(0,100,0,.9)!important;
    }
    #quinto-step button{
        margin: auto;
        margin-top: 2em;
        margin-bottom: 0.5em;
    }
    label{
        margin-bottom:0!important;
    }
    .btn-sms-on{
        background:rgba(20,200,20,.3) !important;
    }
    #btn-sms{
        font-size: 1vw;
        margin-top: 2em!important;
    }
}
/* Stili solo per dispositivi con larghezza massima di 600 pixel (tipicamente dispositivi mobili) */
@media only screen and (max-width: 600px) {
    .input-error{
        border-bottom: 2px solid rgba(100,10,10,.9)!important;
    }

    #guest-registration-procedure{
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently
                                    supported by Chrome, Edge, Opera and Firefox */
        overflow: hidden;

        position: absolute;
        top:0;
        left:0;
        width:100%;
        height: 100vh;
        background: black;
    }
    #guest-registration-procedure .container{
        margin: auto;
        margin-top: 10vh;
        background: white;
        position:relative;
        border: 5px solid rgba(0,0,0,1);
        transition: 1s border;
        padding-top:1em;
    }
    #guest-registration-procedure .container-border{
        border: 5px solid rgba(200,200,200,.5);
    }
    #guest-registration-procedure .container h1{
        text-align: center;
        border: 0;
        margin: 0;
        font-size: calc(26px + 1vw);
        color: black;
        transition: opacity 2s;
    }
    #guest-registration-procedure .container h1 i{
        margin-right: .3em;
    }
    #guest-registration-procedure .container input{
        font-family: 'Source Code Pro', monospace;
        border: 0;
        border-radius: 10px;
        border-bottom: 2px solid rgba(10,10,10,.7);
        /* box-shadow: 1px 0 10px 1px rgba(100,100,100,1); */
        font-size: 4vw;
        padding: 0.5em;
        background: white;
        color: black;
        margin: auto;
        margin-top: 1.5em;
        display: block;
        outline: none;
        transition: opacity 2s;
        width: 100%;
    }
    #guest-registration-procedure .container button{
        font-family: 'Source Code Pro', monospace;
        display: inline-block;
        border: 0;
        border-radius: 10px;
        background: white;
        padding: 0.25em 0.5em;
        cursor: pointer;
        color: black;
        font-weight: bold;
        transition: opacity 2s;
        font-size: 4vw;
        margin-top: 3.5em;
        margin-bottom: 0.5em;
    }
    #guest-registration-procedure #btns{
        display:flex;
        justify-content: space-between;
    }
    #guest-registration-procedure .container button#cancel-btn{
        box-shadow: 1px 0 5px 0.3px rgba(100,10,10,.5);
        background:rgba(100,0,0,.3);
    }
    #guest-registration-procedure .container button#cancel-btn:hover{
        box-shadow: 1px 0 5px 0.5px rgba(100,10,10,.8);
    }
    #guest-registration-procedure .container button#continue-btn{
        box-shadow: 1px 0 5px 0.3px rgba(10,100,10,.5);
        background:rgba(0,100,0,.3);
    }
    #guest-registration-procedure .container button#continue-btn:hover{
        box-shadow: 1px 0 5px 0.5px rgba(10,100,10,.8);
    }

    #sipario-h{
        position: absolute;
        width: 100%;
        height: 100%;
        background: black;
        left: 0;
        top: 0;
        transition: 3s top;
    }
    .sipario-h-off{
        top: 80vh!important;
    }
    .sipario-w{
        position: absolute;
        width: 100%;
        height: 100%;
        background: black;
        left: 0;
        top: 0;
        transition: 3s width;
    }
    .sipario-w-off{
        width: 0!important;
    }
    .step-on{
        z-index: 10;
        opacity: 1;
    }
    .step-off{
        z-index:-1;
        opacity: 0;
    }
    .d-none{
        display:none;
    }

    #secondo-step{
        text-align:center;
    }
    #secondo-step input{
        text-align: center!important;
        font-weight: bold;
        border: 2px solid black!important;
        padding: 0.2em!important;
        font-size: 5vw!important;
        width: 4em!important;
    }
    h3{
        font-size:2.3vw!important;
    }
    #secondo-step h1 {
        font-size: 5vw!important;
    }
    #secondo-step h2 {
        font-size: 4.6vw!important;
    }
    #secondo-step h1 label{
        display:inline-block;
        color: rgba(0,0,0,.8);
    }
    #secondo-step #regenerate-btn {
        box-shadow: 1px 0 5px 0.3px rgba(10,10,100,.5);
        background: rgba(0,0,100,.3);
        margin-top: 1em!important;
    }
    #terzo-step h1{
        color:rgba(0,80,0,.9)!important;
    }
    #terzo-step h1 label{
        color: rgba(0,100,0,.9);
    }
    #terzo-step h2, #quarto-step h2{
        text-align: center;
        font-size: 5.5vw;
        margin-bottom: 1.5em;
    }
    #terzo-step button, #quarto-step button{
        display: block!important;
        margin: auto!important;
        border: 1px solid rgba(0,0,0,.4)!important;
        margin-bottom: 0.5em!important;
    }
    #quarto-step h1 label{
        color: rgba(10,10,10,.8);
    }
    #quarto-step h2{
        font-size:1.5vw;
        margin-top:1em;
    }
    #quarto-step #btns {
        margin-top:5em;
        margin-bottom: 1em;
    }
    #quarto-step #btns button {
        margin:0!important;
        outline:none!important;
    }
    #quarto-step button.selected{
        border: 1px solid rgba(255, 115, 0, 0.9)!important;
        color: rgba(255, 115, 0, 0.9);
        font-weight:bold;
        outline:none!important;
    }
    #quarto-step input[type=date]{
        width: 10em;
        margin-top: 0;
        margin-bottom:1em;
    }
    #quarto-step button{
        font-size:5vw;
    }
    #quarto-step h2{
        font-size: 5.6vw;
    }
    .color-error{
        color:red;
    }
    #quinto-step h1{
        color:rgba(0,80,0,.9)!important;
    }
    #quinto-step h1 label{
        color: rgba(0,100,0,.9)!important;
    }
    #quinto-step button{
        margin: auto;
        margin-top: 2em;
        margin-bottom: 0.5em;
    }
    label{
        margin-bottom:0!important;
    }
    .btn-sms-on{
        background:rgba(20,200,20,.3) !important;
    }
    #btn-sms{
        font-size: 1vw;
        margin-top: 2em!important;
    }
}
    `, "",{"version":3,"sources":["webpack://./css/nuovo_ospite.css"],"names":[],"mappings":"AAAA;IACI;QACI,2BAA2B,EAAE,eAAe;QAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,4BAA4B,EAC7B,2BAA2B;QAClD,iBAAiB,EAAE;kFACuD;QAC1E,gBAAgB;;QAEhB,kBAAkB;QAClB,KAAK;QACL,MAAM;QACN,UAAU;QACV,aAAa;QACb,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;QACjB,iBAAiB;QACjB,+BAA+B;QAC/B,qBAAqB;QACrB,eAAe;IACnB;IACA;QACI,sCAAsC;IAC1C;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,SAAS;QACT,2BAA2B;QAC3B,YAAY;QACZ,sBAAsB;IAC1B;IACA;QACI,kBAAkB;IACtB;IACA;QACI,yCAAyC;QACzC,SAAS;QACT,mBAAmB;QACnB,0CAA0C;QAC1C,oDAAoD;QACpD,gBAAgB;QAChB,cAAc;QACd,iBAAiB;QACjB,YAAY;QACZ,YAAY;QACZ,iBAAiB;QACjB,cAAc;QACd,aAAa;QACb,sBAAsB;QACtB,WAAW;IACf;IACA;QACI,yCAAyC;QACzC,qBAAqB;QACrB,SAAS;QACT,mBAAmB;QACnB,iBAAiB;QACjB,qBAAqB;QACrB,eAAe;QACf,YAAY;QACZ,iBAAiB;QACjB,sBAAsB;QACtB,gBAAgB;QAChB,iBAAiB;QACjB,oBAAoB;IACxB;IACA;QACI,YAAY;QACZ,8BAA8B;IAClC;IACA;QACI,8CAA8C;QAC9C,2BAA2B;IAC/B;IACA;QACI,8CAA8C;IAClD;IACA;QACI,8CAA8C;QAC9C,2BAA2B;IAC/B;IACA;QACI,8CAA8C;IAClD;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,OAAO;QACP,MAAM;QACN,kBAAkB;IACtB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,OAAO;QACP,MAAM;QACN,oBAAoB;IACxB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,UAAU;IACd;IACA;QACI,UAAU;QACV,UAAU;IACd;IACA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;IACA;QACI,oBAAoB;QACpB,4BAA4B;QAC5B,iBAAiB;QACjB,iCAAiC;QACjC,wBAAwB;QACxB,wBAAwB;IAC5B;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,oBAAoB;QACpB,qBAAqB;IACzB;IACA;QACI,8CAA8C;QAC9C,4BAA4B;QAC5B,yBAAyB;IAC7B;IACA;QACI,qDAAqD;IACzD;IACA;QACI,+BAA+B;IACnC;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,oBAAoB;IACxB;IACA;QACI,wBAAwB;QACxB,sBAAsB;QACtB,0CAA0C;QAC1C,8BAA8B;IAClC;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,eAAe;QACf,cAAc;IAClB;IACA;QACI,cAAc;QACd,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,sBAAsB;IAC1B;IACA;QACI,kDAAkD;QAClD,6BAA6B;QAC7B,gBAAgB;QAChB,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,aAAa;QACb,iBAAiB;IACrB;IACA;QACI,SAAS;IACb;IACA;QACI,+BAA+B;IACnC;IACA;QACI,iCAAiC;IACrC;IACA;QACI,YAAY;QACZ,eAAe;QACf,oBAAoB;IACxB;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,wCAAwC;IAC5C;IACA;QACI,cAAc;QACd,yBAAyB;IAC7B;AACJ;AACA,mGAAmG;AACnG;IACI;QACI,qDAAqD;IACzD;;IAEA;QACI,2BAA2B,EAAE,eAAe;QAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,4BAA4B,EAC7B,2BAA2B;QAClD,iBAAiB,EAAE;kFACuD;QAC1E,gBAAgB;;QAEhB,kBAAkB;QAClB,KAAK;QACL,MAAM;QACN,UAAU;QACV,aAAa;QACb,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;QACjB,iBAAiB;QACjB,+BAA+B;QAC/B,qBAAqB;QACrB,eAAe;IACnB;IACA;QACI,sCAAsC;IAC1C;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,SAAS;QACT,2BAA2B;QAC3B,YAAY;QACZ,sBAAsB;IAC1B;IACA;QACI,kBAAkB;IACtB;IACA;QACI,yCAAyC;QACzC,SAAS;QACT,mBAAmB;QACnB,0CAA0C;QAC1C,oDAAoD;QACpD,cAAc;QACd,cAAc;QACd,iBAAiB;QACjB,YAAY;QACZ,YAAY;QACZ,iBAAiB;QACjB,cAAc;QACd,aAAa;QACb,sBAAsB;QACtB,WAAW;IACf;IACA;QACI,yCAAyC;QACzC,qBAAqB;QACrB,SAAS;QACT,mBAAmB;QACnB,iBAAiB;QACjB,qBAAqB;QACrB,eAAe;QACf,YAAY;QACZ,iBAAiB;QACjB,sBAAsB;QACtB,cAAc;QACd,iBAAiB;QACjB,oBAAoB;IACxB;IACA;QACI,YAAY;QACZ,8BAA8B;IAClC;IACA;QACI,8CAA8C;QAC9C,2BAA2B;IAC/B;IACA;QACI,8CAA8C;IAClD;IACA;QACI,8CAA8C;QAC9C,2BAA2B;IAC/B;IACA;QACI,8CAA8C;IAClD;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,OAAO;QACP,MAAM;QACN,kBAAkB;IACtB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,OAAO;QACP,MAAM;QACN,oBAAoB;IACxB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,UAAU;IACd;IACA;QACI,UAAU;QACV,UAAU;IACd;IACA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;IACA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,iCAAiC;QACjC,wBAAwB;QACxB,wBAAwB;QACxB,oBAAoB;IACxB;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,oBAAoB;QACpB,qBAAqB;IACzB;IACA;QACI,8CAA8C;QAC9C,4BAA4B;QAC5B,yBAAyB;IAC7B;IACA;QACI,+BAA+B;IACnC;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,oBAAoB;IACxB;IACA;QACI,wBAAwB;QACxB,sBAAsB;QACtB,0CAA0C;QAC1C,8BAA8B;IAClC;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,eAAe;QACf,cAAc;IAClB;IACA;QACI,cAAc;QACd,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,sBAAsB;IAC1B;IACA;QACI,kDAAkD;QAClD,6BAA6B;QAC7B,gBAAgB;QAChB,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,aAAa;QACb,iBAAiB;IACrB;IACA;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,SAAS;IACb;IACA;QACI,+BAA+B;IACnC;IACA;QACI,iCAAiC;IACrC;IACA;QACI,YAAY;QACZ,eAAe;QACf,oBAAoB;IACxB;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,wCAAwC;IAC5C;IACA;QACI,cAAc;QACd,yBAAyB;IAC7B;AACJ","sourcesContent":["@media only screen and (min-width: 600px) {\n    #guest-registration-procedure{\n        -webkit-touch-callout: none; /* iOS Safari */\n        -webkit-user-select: none; /* Safari */\n        -khtml-user-select: none; /* Konqueror HTML */\n        -moz-user-select: none; /* Old versions of Firefox */\n        -ms-user-select: none; /* Internet Explorer/Edge */\n        user-select: none; /* Non-prefixed version, currently\n                                    supported by Chrome, Edge, Opera and Firefox */\n        overflow: hidden;\n\n        position: absolute;\n        top:0;\n        left:0;\n        width:100%;\n        height: 100vh;\n        background: black;\n    }\n    #guest-registration-procedure .container{\n        margin: auto;\n        margin-top: 10vh;\n        background: white;\n        position:relative;\n        border: 5px solid rgba(0,0,0,1);\n        transition: 1s border;\n        padding-top:1em;\n    }\n    #guest-registration-procedure .container-border{\n        border: 5px solid rgba(200,200,200,.5);\n    }\n    #guest-registration-procedure .container h1{\n        text-align: center;\n        border: 0;\n        margin: 0;\n        font-size: calc(26px + 1vw);\n        color: black;\n        transition: opacity 2s;\n    }\n    #guest-registration-procedure .container h1 i{\n        margin-right: .3em;\n    }\n    #guest-registration-procedure .container input{\n        font-family: 'Source Code Pro', monospace;\n        border: 0;\n        border-radius: 10px;\n        border-bottom: 2px solid rgba(10,10,10,.7);\n        /* box-shadow: 1px 0 10px 1px rgba(100,100,100,1); */\n        font-size: 1.5vw;\n        padding: 0.5em;\n        background: white;\n        color: black;\n        margin: auto;\n        margin-top: 1.5em;\n        display: block;\n        outline: none;\n        transition: opacity 2s;\n        width: 100%;\n    }\n    #guest-registration-procedure .container button{\n        font-family: 'Source Code Pro', monospace;\n        display: inline-block;\n        border: 0;\n        border-radius: 10px;\n        background: white;\n        padding: 0.25em 0.5em;\n        cursor: pointer;\n        color: black;\n        font-weight: bold;\n        transition: opacity 2s;\n        font-size: 1.5vw;\n        margin-top: 3.5em;\n        margin-bottom: 0.5em;\n    }\n    #guest-registration-procedure #btns{\n        display:flex;\n        justify-content: space-between;\n    }\n    #guest-registration-procedure .container button#cancel-btn{\n        box-shadow: 1px 0 5px 0.3px rgba(100,10,10,.5);\n        background:rgba(100,0,0,.3);\n    }\n    #guest-registration-procedure .container button#cancel-btn:hover{\n        box-shadow: 1px 0 5px 0.5px rgba(100,10,10,.8);\n    }\n    #guest-registration-procedure .container button#continue-btn{\n        box-shadow: 1px 0 5px 0.3px rgba(10,100,10,.5);\n        background:rgba(0,100,0,.3);\n    }\n    #guest-registration-procedure .container button#continue-btn:hover{\n        box-shadow: 1px 0 5px 0.5px rgba(10,100,10,.8);\n    }\n\n    #sipario-h{\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        background: black;\n        left: 0;\n        top: 0;\n        transition: 3s top;\n    }\n    .sipario-h-off{\n        top: 100vh!important;\n    }\n    .sipario-w{\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        background: black;\n        left: 0;\n        top: 0;\n        transition: 3s width;\n    }\n    .sipario-w-off{\n        width: 0!important;\n    }\n    .step-on{\n        z-index: 10;\n        opacity: 1;\n    }\n    .step-off{\n        z-index:-1;\n        opacity: 0;\n    }\n    .d-none{\n        display:none;\n    }\n\n    #secondo-step{\n        text-align:center;\n    }\n    #secondo-step input{\n        width: 8vw!important;\n        text-align: center!important;\n        font-weight: bold;\n        border: 2px solid black!important;\n        font-size: 2vw!important;\n        padding: 0.2em!important;\n    }\n    h3{\n        font-size:2.3vw!important;\n    }\n    #secondo-step h1 label{\n        display:inline-block;\n        color: rgba(0,0,0,.8);\n    }\n    #secondo-step #regenerate-btn {\n        box-shadow: 1px 0 5px 0.3px rgba(10,10,100,.5);\n        background: rgba(0,0,100,.3);\n        margin-top: 1em!important;\n    }\n    .input-error{\n        border-bottom: 2px solid rgba(100,10,10,.9)!important;\n    }\n    #terzo-step h1{\n        color:rgba(0,80,0,.9)!important;\n    }\n    #terzo-step h1 label{\n        color: rgba(0,100,0,.9);\n    }\n    #terzo-step h2, #quarto-step h2{\n        text-align: center;\n        font-size: 1.4vw;\n        margin-bottom: 1.5em;\n    }\n    #terzo-step button, #quarto-step button{\n        display: block!important;\n        margin: auto!important;\n        border: 1px solid rgba(0,0,0,.4)!important;\n        margin-bottom: 0.5em!important;\n    }\n    #quarto-step h1 label{\n        color: rgba(10,10,10,.8);\n    }\n    #quarto-step h2{\n        font-size:1.5vw;\n        margin-top:1em;\n    }\n    #quarto-step #btns {\n        margin-top:6em;\n        margin-bottom: 1em;\n    }\n    #quarto-step #btns button {\n        margin:0!important;\n        outline:none!important;\n    }\n    #quarto-step button.selected{\n        border: 1px solid rgba(255, 115, 0, 0.9)!important;\n        color: rgba(255, 115, 0, 0.9);\n        font-weight:bold;\n        outline:none!important;\n    }\n    #quarto-step input[type=date]{\n        width: 10em;\n        margin-top: 0;\n        margin-bottom:1em;\n    }\n    .color-error{\n        color:red;\n    }\n    #quinto-step h1{\n        color:rgba(0,80,0,.9)!important;\n    }\n    #quinto-step h1 label{\n        color: rgba(0,100,0,.9)!important;\n    }\n    #quinto-step button{\n        margin: auto;\n        margin-top: 2em;\n        margin-bottom: 0.5em;\n    }\n    label{\n        margin-bottom:0!important;\n    }\n    .btn-sms-on{\n        background:rgba(20,200,20,.3) !important;\n    }\n    #btn-sms{\n        font-size: 1vw;\n        margin-top: 2em!important;\n    }\n}\n/* Stili solo per dispositivi con larghezza massima di 600 pixel (tipicamente dispositivi mobili) */\n@media only screen and (max-width: 600px) {\n    .input-error{\n        border-bottom: 2px solid rgba(100,10,10,.9)!important;\n    }\n\n    #guest-registration-procedure{\n        -webkit-touch-callout: none; /* iOS Safari */\n        -webkit-user-select: none; /* Safari */\n        -khtml-user-select: none; /* Konqueror HTML */\n        -moz-user-select: none; /* Old versions of Firefox */\n        -ms-user-select: none; /* Internet Explorer/Edge */\n        user-select: none; /* Non-prefixed version, currently\n                                    supported by Chrome, Edge, Opera and Firefox */\n        overflow: hidden;\n\n        position: absolute;\n        top:0;\n        left:0;\n        width:100%;\n        height: 100vh;\n        background: black;\n    }\n    #guest-registration-procedure .container{\n        margin: auto;\n        margin-top: 10vh;\n        background: white;\n        position:relative;\n        border: 5px solid rgba(0,0,0,1);\n        transition: 1s border;\n        padding-top:1em;\n    }\n    #guest-registration-procedure .container-border{\n        border: 5px solid rgba(200,200,200,.5);\n    }\n    #guest-registration-procedure .container h1{\n        text-align: center;\n        border: 0;\n        margin: 0;\n        font-size: calc(26px + 1vw);\n        color: black;\n        transition: opacity 2s;\n    }\n    #guest-registration-procedure .container h1 i{\n        margin-right: .3em;\n    }\n    #guest-registration-procedure .container input{\n        font-family: 'Source Code Pro', monospace;\n        border: 0;\n        border-radius: 10px;\n        border-bottom: 2px solid rgba(10,10,10,.7);\n        /* box-shadow: 1px 0 10px 1px rgba(100,100,100,1); */\n        font-size: 4vw;\n        padding: 0.5em;\n        background: white;\n        color: black;\n        margin: auto;\n        margin-top: 1.5em;\n        display: block;\n        outline: none;\n        transition: opacity 2s;\n        width: 100%;\n    }\n    #guest-registration-procedure .container button{\n        font-family: 'Source Code Pro', monospace;\n        display: inline-block;\n        border: 0;\n        border-radius: 10px;\n        background: white;\n        padding: 0.25em 0.5em;\n        cursor: pointer;\n        color: black;\n        font-weight: bold;\n        transition: opacity 2s;\n        font-size: 4vw;\n        margin-top: 3.5em;\n        margin-bottom: 0.5em;\n    }\n    #guest-registration-procedure #btns{\n        display:flex;\n        justify-content: space-between;\n    }\n    #guest-registration-procedure .container button#cancel-btn{\n        box-shadow: 1px 0 5px 0.3px rgba(100,10,10,.5);\n        background:rgba(100,0,0,.3);\n    }\n    #guest-registration-procedure .container button#cancel-btn:hover{\n        box-shadow: 1px 0 5px 0.5px rgba(100,10,10,.8);\n    }\n    #guest-registration-procedure .container button#continue-btn{\n        box-shadow: 1px 0 5px 0.3px rgba(10,100,10,.5);\n        background:rgba(0,100,0,.3);\n    }\n    #guest-registration-procedure .container button#continue-btn:hover{\n        box-shadow: 1px 0 5px 0.5px rgba(10,100,10,.8);\n    }\n\n    #sipario-h{\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        background: black;\n        left: 0;\n        top: 0;\n        transition: 3s top;\n    }\n    .sipario-h-off{\n        top: 80vh!important;\n    }\n    .sipario-w{\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        background: black;\n        left: 0;\n        top: 0;\n        transition: 3s width;\n    }\n    .sipario-w-off{\n        width: 0!important;\n    }\n    .step-on{\n        z-index: 10;\n        opacity: 1;\n    }\n    .step-off{\n        z-index:-1;\n        opacity: 0;\n    }\n    .d-none{\n        display:none;\n    }\n\n    #secondo-step{\n        text-align:center;\n    }\n    #secondo-step input{\n        text-align: center!important;\n        font-weight: bold;\n        border: 2px solid black!important;\n        padding: 0.2em!important;\n        font-size: 5vw!important;\n        width: 4em!important;\n    }\n    h3{\n        font-size:2.3vw!important;\n    }\n    #secondo-step h1 {\n        font-size: 5vw!important;\n    }\n    #secondo-step h2 {\n        font-size: 4.6vw!important;\n    }\n    #secondo-step h1 label{\n        display:inline-block;\n        color: rgba(0,0,0,.8);\n    }\n    #secondo-step #regenerate-btn {\n        box-shadow: 1px 0 5px 0.3px rgba(10,10,100,.5);\n        background: rgba(0,0,100,.3);\n        margin-top: 1em!important;\n    }\n    #terzo-step h1{\n        color:rgba(0,80,0,.9)!important;\n    }\n    #terzo-step h1 label{\n        color: rgba(0,100,0,.9);\n    }\n    #terzo-step h2, #quarto-step h2{\n        text-align: center;\n        font-size: 5.5vw;\n        margin-bottom: 1.5em;\n    }\n    #terzo-step button, #quarto-step button{\n        display: block!important;\n        margin: auto!important;\n        border: 1px solid rgba(0,0,0,.4)!important;\n        margin-bottom: 0.5em!important;\n    }\n    #quarto-step h1 label{\n        color: rgba(10,10,10,.8);\n    }\n    #quarto-step h2{\n        font-size:1.5vw;\n        margin-top:1em;\n    }\n    #quarto-step #btns {\n        margin-top:5em;\n        margin-bottom: 1em;\n    }\n    #quarto-step #btns button {\n        margin:0!important;\n        outline:none!important;\n    }\n    #quarto-step button.selected{\n        border: 1px solid rgba(255, 115, 0, 0.9)!important;\n        color: rgba(255, 115, 0, 0.9);\n        font-weight:bold;\n        outline:none!important;\n    }\n    #quarto-step input[type=date]{\n        width: 10em;\n        margin-top: 0;\n        margin-bottom:1em;\n    }\n    #quarto-step button{\n        font-size:5vw;\n    }\n    #quarto-step h2{\n        font-size: 5.6vw;\n    }\n    .color-error{\n        color:red;\n    }\n    #quinto-step h1{\n        color:rgba(0,80,0,.9)!important;\n    }\n    #quinto-step h1 label{\n        color: rgba(0,100,0,.9)!important;\n    }\n    #quinto-step button{\n        margin: auto;\n        margin-top: 2em;\n        margin-bottom: 0.5em;\n    }\n    label{\n        margin-bottom:0!important;\n    }\n    .btn-sms-on{\n        background:rgba(20,200,20,.3) !important;\n    }\n    #btn-sms{\n        font-size: 1vw;\n        margin-top: 2em!important;\n    }\n}\n    "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
